module.exports = __webpack_public_path__ + "static/media/avatar_44.e9092d2b.svg";